<template>
  <div class="register-client">
    <div class="preloader" v-if="preloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <form class="client-form">
      <div class="form__title">
        Запланировать
        <br />презентацию
      </div>
      <div class="form__title">{{ collectionInfo.collectionName }}</div>

      <label class="search-label">
        <input
          type="text"
          name="company"
          autocomplete="off"
          placeholder="Клиент"
          v-model.trim="company"
          @input="findClient"
          :class="{ error: $v.company.$dirty && !$v.company.required }"
        />
        <div class="search-result">
          <p
            v-for="(result, index) in searchResult"
            @click="filInfo(index)"
            :key="index"
          >
            {{ result.title }}
          </p>
        </div>
      </label>
      <label class="error" v-if="$v.company.$dirty && !$v.company.required"
        >Поле 'Компания' не должно быть пустым</label
      >

      <input
        type="text"
        name="place"
        autocomplete="off"
        placeholder="Регион"
        v-model.trim="place"
        :class="{ error: $v.place.$dirty && !$v.place.required }"
      />
      <label class="error" v-if="$v.place.$dirty && !$v.place.required"
        >Поле 'Регион' не должно быть пустым</label
      >

      <input
        type="text"
        name="phone"
        autocomplete="off"
        placeholder="Телефон"
        v-model.trim="phone"
        :class="{ error: $v.phone.$dirty && !$v.phone.required }"
      />
      <label class="error" v-if="$v.phone.$dirty && !$v.phone.required"
        >Поле 'Телефон' не должно быть пустым</label
      >

      <input
        type="text"
        name="email"
        autocomplete="off"
        placeholder="email"
        v-model.trim="email"
        :class="{ error: $v.email.$dirty && !$v.email.email }"
      />

      <label class="error" v-if="$v.email.$dirty && !$v.email.email"
        >Введите корректный e-mail</label
      >

      <input
        type="date"
        name="presentationDate"
        class="presentationDate"
        placeholder="Дата Презентации дд.мм.гггг"
        v-model.trim="presentationDate"
        :class="{ error: $v.place.$dirty && !$v.place.required }"
      />
      <label
        class="error"
        v-if="$v.presentationDate.$dirty && !$v.presentationDate.required"
        >Поле 'Дата Презентации' не должно быть пустым</label
      >

      <input
        type="submit"
        :class="{blockedButton: blockButton}"
        value="зарегистрировать"
        id="registerClient"
        v-on:click.prevent="sendForm"
      />
    </form>
  </div>
</template>
<script>
import { email, required, minLength } from "vuelidate/lib/validators"; //валидатор

export default {
  data: () => ({
    collectionInfo: {},
    company: "",
    place: "",
    presentationDate: "",
    phone: "",
    email: "",
    searchResult: [],
    blockButton: false,
    preloader: false
  }),
  validations: {
    company: { required },
    place: { required },
    presentationDate: { required },
    phone: { required },
    email: { email },
  },
  methods: {
    sendForm() {
      this.blockButton = true;
      this.preloader = true;
      let self = this;

      if (this.$v.$invalid) {
        this.$v.$touch();
        this.preloader = false;
        this.blockButton = false;
        return;
      } else {

        let data = {
          title: this.company,
          region: this.place,
          phone: this.phone,
          email: this.email,
          description: 'Комментарий',
          presentationDate: this.presentationDate
        };

        this.$store.dispatch('SAVE_NEW_COMPANY', data)  //Сохранить компанию
          .then(resp => {
            this.$store.dispatch('PRESENTATION_REGISTER', data) //Зарегистрировать новую презентацию
            .then(r=>{
              this.$router.push("/plan/" + r.data.data.presentationId);  //На страницу план/цель
            })
        })
      }
    },
    findClient(e) {
      let that = this;
      if (e.target.value.length >= 4) {
        this.$store
          .dispatch("COMPANY_SEARCH", this.company)
          .then((response) => {
            that.searchResult = response.data.data;
          });
      } else {
        that.searchResult = [];
        this.place = "";
        this.phone = "";
        this.email = "";
      }
    },
    filInfo(index) {
      let choice = this.searchResult[index];
      this.company = choice.title;
      this.place = choice.region;
      this.phone = choice.phone;
      this.email = choice.email;
      this.searchResult = [];
    },
  },
  created() {
    this.collectionInfo = this.$localStorageGet("RegistrationCollectionInfo");
  },
};
</script>
<style lang="scss" scoped>
.presentationDate::-webkit-inner-spin-button {
  display: none;
}
.client-form {
  justify-content: flex-start;
  padding-top: 50px;
}
input:not(#registerClient) {
  padding-left: 10px;
}
input[type="date"]::-webkit-calendar-picker-indicator {
  background: url("https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/calendar-16.png")
    center 80% no-repeat;
  color: rgba(0, 0, 0, 0);
  opacity: 1;
}
input[type="submit"] {
  position: fixed;
  bottom: 0;
  margin-bottom: 0;
  width: 100%;
  left: 0;
}
.search-label {
  margin: 0;
  position: relative;
}
.search-result {
  width: 100%;
  background: #fff;
  position: absolute;
  top: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-height: 400px;
  overflow-y: auto;
  p {
    padding: 10px;
    font-size: 14px;
  }
}
</style>